import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../core/api.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.sass']
})
export class ForgotPasswordComponent implements OnInit {
  user: any = {};
  constructor(private router: Router,private _adminService: ApiService,private toastr: ToastrService) { }

  ngOnInit(): void {
  }
getPassword(){
  let url = "users/forgot-password"
  this._adminService.login(url,this.user).subscribe((response)=>{
      if(response.success==true){  
        this.toastr.success('Check Your Email');
          this.router.navigate(['login']);
      }else{
        this.toastr.error('Error!', response.message);  
      }
  })
}
}
